import type { SVGProps } from 'react'
const SvgFunnel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.33664 13.3327C7.14775 13.3327 6.98942 13.2688 6.86164 13.141C6.73386 13.0132 6.66998 12.8549 6.66998 12.666V8.66602L2.80331 3.73268C2.63664 3.51046 2.61164 3.27713 2.72831 3.03268C2.84498 2.78824 3.04775 2.66602 3.33664 2.66602H12.67C12.9589 2.66602 13.1616 2.78824 13.2783 3.03268C13.395 3.27713 13.37 3.51046 13.2033 3.73268L9.33664 8.66602V12.666C9.33664 12.8549 9.27275 13.0132 9.14498 13.141C9.0172 13.2688 8.85886 13.3327 8.66998 13.3327H7.33664ZM8.00331 8.19935L11.3033 3.99935H4.70331L8.00331 8.19935Z"
      fill="#757575"
    />
  </svg>
)

export default SvgFunnel
